import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import dayjs from "dayjs"
import { getActualizacionFiltrosReportes, getOficinasRegion } from '../../../services/IndicadorService'
import { setListadoFiltros, isLoading, setFiltrosSeleccionados, indicadoresOficinaAction, setVerSoloCompromisos, setTabActivo } from '../../../redux/AppSlice'
import { getIndicadoresOficina } from '../../../services/IndicadorService';
import { setRegionDefecto } from '../../../services/helperService';
import { DefinirTabActivo } from '../../../services/utilService';
import { toast } from "react-toastify"
import { codigoPerfiles } from '../../interfaces/enumeradores';

export function FiltroOficina({ setOficinas, oficinas }: any) {
    const dispatch = useDispatch()
    const filtros = useSelector((store: any) => store.appReducer.filtrosReportes)
    const usuario = useSelector((store: any) => store.appReducer.usuario)
    const seleccionfiltros = useSelector((store: any) => store.appReducer.filtrosReporteSeleccionado)
    const tabActivo = useSelector((store: any) => store.appReducer.tabsActivos.oficina)
    const gestorVeSoloSusCompromisos = useSelector((store: any) => store.appReducer.gestorVeSoloSusCompromisos)
    const mesSeleccionado = seleccionfiltros.mes

    const onChangeFiltro = async (nombreFiltro: string, e: any) => {
        if (nombreFiltro == 'agno') {
            const data = await getActualizacionFiltrosReportes(parseInt(e.target.value), 0)
            dispatch(setListadoFiltros({ ...filtros, periodos: data.actualizacion }))

            //si el mes seleccionado no existe en el año filtrado, se actualiza al ultimo mes disponible del año seleccionado
            if (!data?.actualizacion?.some((x: any) => x.value === mesSeleccionado)) {
                dispatch(setFiltrosSeleccionados({ ...seleccionfiltros, mes: data.actualizacion[0].value, [nombreFiltro]: parseInt(e.target.value) }))
            }
            else {
                dispatch(setFiltrosSeleccionados({ ...seleccionfiltros, [nombreFiltro]: parseInt(e.target.value) }))
            }
        }
        else if (nombreFiltro == 'mes') {
            const data = await getActualizacionFiltrosReportes(0, parseInt(e.target.value))

            dispatch(setListadoFiltros({ ...filtros, agnos: data.actualizacion }))
            dispatch(setFiltrosSeleccionados({ ...seleccionfiltros, [nombreFiltro]: parseInt(e.target.value) }))
        }
        else if (nombreFiltro == 'idRegion') {
            const data = await getOficinasRegion(parseInt(e.target.value))

            dispatch(setFiltrosSeleccionados({ ...seleccionfiltros, idRegion: parseInt(e.target.value), idOficina: parseInt(data[0]?.value) }))
            setOficinas(data)
        }
        else {
            dispatch(setFiltrosSeleccionados({ ...seleccionfiltros, [nombreFiltro]: parseInt(e.target.value) }))
        }
    }

    const actualizarGrillaIndicadores = async () => {
        try {
            dispatch(isLoading(true))
            const filtros = {
                ...seleccionfiltros,
                GestorVeSoloSusCompromisos: gestorVeSoloSusCompromisos
            }

            const data = await getIndicadoresOficina(filtros)
            const tab: number = DefinirTabActivo(tabActivo, data)

            dispatch(setTabActivo({ oficina: tab ?? 1 }))
            dispatch(indicadoresOficinaAction(data))
        }
        catch {
            toast.error('Ha ocurrido un error, inténtelo nuevamente.')
        }
        finally {
            dispatch(isLoading(false))
        }
    }

    return (
        <>
            <div className='row'>
                <div className='col-md-3'>
                    <label className='form-label'>Año:</label>
                    <div>
                        {filtros?.agnos ? <select
                            className='form-select '
                            data-kt-select2='true'
                            data-placeholder='Select option'
                            data-allow-clear='true'
                            onChange={e => onChangeFiltro('agno', e)}
                            defaultValue={seleccionfiltros?.agno.toString()}
                        >
                            {filtros?.agnos.map((item: any, index: number) => (
                                <option key={item.value} value={item.glosa}>{item.glosa}</option>
                            ))}
                        </select> : null}
                    </div>
                </div>
                <div className='col-md-3'>
                    <label className='form-label'>Período:</label>

                    <div>
                        {filtros?.periodos ? <select
                            className='form-select '
                            data-kt-select2='true'
                            data-placeholder='Select option'
                            data-allow-clear='true'
                            onChange={e => onChangeFiltro('mes', e)}
                            defaultValue={seleccionfiltros?.mes.toString()}
                        >
                            {filtros?.periodos.map((item: any, index: number) => (
                                <option key={item.value} value={item.value.toString()}>{item.glosa}</option>
                            ))}
                        </select> : null}
                    </div>
                </div>
                <div className='col-md-3'>
                    <label className='form-label'>Región:</label>
                    <div>
                        {usuario && filtros ?
                            <select
                                className='form-select '
                                data-kt-select2='true'
                                data-placeholder='Select option'
                                data-allow-clear='true'
                                onChange={e => onChangeFiltro('idRegion', e)}
                                defaultValue={seleccionfiltros.idRegion || setRegionDefecto(usuario, filtros)}
                            >
                                {filtros?.regiones.map((item: any, index: number) => (
                                    <option key={item.value} value={item.value.toString()}>{item.glosa}</option>
                                ))}
                            </select> : null}
                    </div>
                </div>
                <div className='col-md-3'>
                    <label className='form-label'>Oficina:</label>
                    <div>
                        {oficinas ?
                            <select
                                className='form-select '
                                data-kt-select2='true'
                                data-placeholder='Select option'
                                data-allow-clear='true'
                                onChange={e => onChangeFiltro('idOficina', e)}
                                defaultValue={oficinas[0].value.toString()}
                            >
                                {oficinas?.map((item: any, index: number) => (
                                    <option key={item.value} value={item.value.toString()}>{item.glosa}</option>
                                ))}
                            </select> : null}
                    </div>
                </div>

            </div>
            <div className='row mt-2'>
                <div className='col-md-3'>
                    <label className='form-label'>Area:</label>

                    <div>
                        <select
                            className='form-select '
                            data-kt-select2='true'
                            data-placeholder='Select option'
                            data-allow-clear='true'
                            onChange={e => onChangeFiltro('idArea', e)}
                            defaultValue={seleccionfiltros.idArea?.toString() ?? ''}
                        >
                            <option value=''>Todas</option>
                            {filtros?.areas.map((item: any, index: number) => (
                                <option key={item.value} value={item.value.toString()}>{item.glosa}</option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className='col-md-3'>
                    <label className='form-label'>Compromiso:</label>
                    <div>
                        <select
                            className='form-select '
                            data-kt-select2='true'
                            data-placeholder='Select option'
                            data-allow-clear='true'
                            defaultValue={seleccionfiltros.idCategoria?.toString() ?? ''}
                            onChange={e => onChangeFiltro('idCategoria', e)}
                        >
                            <option value=''>Todos</option>
                            {filtros?.compromisos.filter((x: any) => x.esNacional)?.map((item: any, index: number) => (
                                <option key={item.value} value={item.value.toString()}>{item.glosa}</option>
                            ))}
                        </select>
                    </div>
                </div>
                {usuario?.rol.codigo == codigoPerfiles.GESTOR ?
                    <div className='col-md-3 mt-2'>
                        <label className='form-label'>Mis compromisos:</label>
                        <div style={{ textAlign: 'center' }}>
                            <input
                                className='form-check-input mt-1'
                                type='checkbox'
                                value=''
                                checked={gestorVeSoloSusCompromisos}
                                style={{
                                    height: '30px',
                                    width: '30px'
                                }}
                                name='notifications'
                                onChange={() =>
                                    dispatch(setVerSoloCompromisos(!gestorVeSoloSusCompromisos))
                                }
                            />
                        </div>
                    </div> : null}
                <div className='col-md-2'>
                    <br></br>
                    <div className='d-flex justify-content-center pt-3'>
                        <button type='button' onClick={() => actualizarGrillaIndicadores()} className='btn btn-sm btn-primary' data-kt-menu-dismiss='true'>
                            Aplicar
                        </button>
                    </div>
                </div>
            </div>
        </>
    )
}